export interface StockEnquirySalesOrder {
  id: string;
  type: string;
  salesOrderHeaderId: string;
  orderNo: string;
  customerKey: string;
  customerName: string;
  customerCurrency: string;
  customerOrderRef: string;
  quantity: number;
  unitOfMeasure: string;
  allocatedQuantity: number;
  poAllocationQuantity: number;
  despatchedQuantity: number;
  balanceOnOrder: number;
  price: number;
  dueDate: Date;
  orderStatus: string;
  colour: string;
  sequence: number;
  productKey: string;
  commentsExist: boolean;
  selected: boolean;
}
